import React from 'react';
import Tools from '../../util/tools';
import HTTP from '../../util/http';
import Link from '../Link';
import { componentDidMount } from '../Lifecycle';
import './index.scss';


const NavItems = [
  {
    key: 'index',
    name: '首页',
    url: './'
  },
  {
    key: 'me',
    name: '我的',
    url: './me.html'
  }
];

const FixedFooterNav = ({ activeNav = null, className, ...props }) => {

  const currentNav = Tools.getCurrentPathname('index');

  componentDidMount(() => {

  });

  const ItemHTML = ({ key, name, url }, index) => {

    const isActive = (key === activeNav || key === currentNav) ? true : false;

    const pic = `${HTTP.PUBLIC_URL}/img/icon-${key}${isActive ? '-active' : ''}.png`;

    return (
      <Link
        className={"com-fixed-footer-nav-item" + (isActive ? ' active' : '')}
        href={url}
        key={index}>
        <img src={pic} alt="" />
        {name}
      </Link>
    )
  }

  return (
    <div
      className={`com-fixed-footer-nav ${className ? className : ''}`}
      {...props}
    >
      {
        NavItems.map((nav, index) => (ItemHTML(nav, index)))
      }
    </div>
  )
}


export default FixedFooterNav;